import React, { useState,useEffect } from 'react';
import {FaHome} from 'react-icons/fa';
import {IoIosArrowForward} from 'react-icons/io';
import { NavLink } from 'react-router-dom';
import { Grid, CircularProgress } from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';
import {MdDelete} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';




import './MessageAdmin.css';
import { Button,Pagination,Table } from 'react-bootstrap';
import { BsTable } from 'react-icons/bs';
import {deleteReview} from '../../actions/review';
import TableIn from '../TableInput';
// import ReviewCard from './hooks/useTable.js';



const pageSize = 7;

function MessageAdmin(props) {
    const navigate = useNavigate();
    const reviews = useSelector((state)=>state.review);

    const dispatch = useDispatch();
    
    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));
    
    // let Auth = useSelector((state)=>state.auth);
    const [posts,setPosts]= useState();
    const [paginatedPosts, setpaginatedPosts] = useState(reviews);
    let activeNum= localStorage.getItem('activeTab');
    const [currentPage, setCurrentPage] = useState(1);
    

    
    
    // const [Id,setId]= useState(0) ;

    

    // function indexNum(Id) {
    //     setId(prevState =>{
    //         return{
    //              ...prevState,
    //              counter : prevState.Id +1
    //         }
    //      })
    // }
    
    useEffect(()=>{
        setPosts(reviews);
        setpaginatedPosts(_(reviews).slice(0).take(pageSize).value()); 
        pagination(activeNum);
    },[reviews]);

    

    const pageCount = posts? Math.ceil(posts.length/pageSize) :0;
    const pages = _.range(1,pageCount+1);

   const pagination =(pageNo) =>{
    
       localStorage.setItem('activeTab',pageNo);
       setCurrentPage(pageNo);
       const startIndex = (pageNo - 1) * pageSize;
       const paginatedPost = _(reviews).slice(startIndex).take(pageSize).value();
       setpaginatedPosts(paginatedPost);
       
   }
  

    

    return (
        
        <div>
           
           
            <div className={props.isOpen?'view2':'view1'}>
             
             <div className='DashboardHeader'>
                 <div className='pull-left'>
                     <div className='page-title'>Message Management</div>
                 </div>
                
                 <ol className='pull-right'>
                     <li style={{display:'inline-block'}}>
                         <FaHome style={{verticalAlign:'text-top'}} />
                         <NavLink className='dashLink' to='/admin/dashboard' style={{verticalAlign:'center'}}> Home</NavLink>
                         <IoIosArrowForward style={{verticalAlign:'text-bottom'}} />
                     </li>
                     <li active >Message Management</li>
                     
                 </ol>
             </div>

            

             <div className='contenu'>
             {
               !reviews.length?<CircularProgress />:(
                        <div>
                            {/* <Table className='tableau' striped bordered hover variant="light" sm='12' >
                                <thead dataField="id" dataFormat={Id}>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Messsage</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { posts.map(rev =>{
                                        return(
                                            <tr className='List'>
                                                
                                                <td key={rev._id}>{rev.name}</td>
                                                <td key={rev._id}>{rev.address}</td>
                                                <td className='message' key={rev._id}>{rev.description}</td>
                                                <td key={rev._id}>{rev.createdAt}</td>
                                                <td ><MdDelete className='DeleteIcon' onClick={()=>dispatch(deleteReview(rev._id))} /> </td>
                                            </tr>
                                        )
                                    })
                                    
                                    }
                                </tbody>
                            </Table> */}

                            <Table className='tableau'striped bordered hover variant="light" sm='12' >
                                <thead>
                                    <tr>
                                        
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Message</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        

                                        
                                         paginatedPosts.map((post,index)=>(
                                        <tr key={index}>
                                            
                                            <td>{post.name}</td>
                                            <td>{post.address}</td>
                                            <td>{post.description}</td>
                                            <td>{post.createdAt}</td>
                                            <td><MdDelete className='DeleteIcon' onClick={
                                                (e)=>
                                            {
                                                
                                                dispatch(deleteReview(post._id));
                                                
                                                }
                                                } /> </td>
                                        </tr>
                                    ))  }
                                </tbody>
                            </Table>
                            { pageCount===1?null:(
                                <nav className='d-flex justify-content-center'>
                                <ul className='pagination'>
                                    {
                                        pages.map((page)=>(
                                            <li  className={
                                                page === currentPage ?'page-item active':'page-item'
                                                }>
                                                 <p className='page-link'
                                                 onClick={()=>pagination(page)}
                                                 >
                                                    {page}
                                                </p>
                                            </li>
                                        ))
                                    }
                                   
                                    
                                </ul>
                            </nav>)}
                            
                            {/* <TableIn /> */}
                                
                            

                            



                            {/* <p key={rev._id}>{rev.name} </p>
                            <p key={rev._id}>{rev.address} </p>
                            <p key={rev._id}>{rev.description} </p> */}
                        </div>
               )
            }


             
             </div>
             {/* <Button onClick={handleClick}>Action</Button> */}
         </div>
              
        </div>
        
    )
}

export default MessageAdmin
